import { render, staticRenderFns } from "./ProjectGovs.vue?vue&type=template&id=61def201&"
import script from "./ProjectGovs.vue?vue&type=script&lang=js&"
export * from "./ProjectGovs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports